import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';

export async function request({ state, commit }) {
  if (state.requested) return;
  commit('SET_STATE', { key: 'requested', value: true });

  const auth = getAuth();
  const db = getFirestore();

  onAuthStateChanged(auth, async (response) => {
    let claimResp;
    let user;
    let organization;
    if (response) {
      claimResp = await auth.currentUser.getIdTokenResult();
      const userDoc = await getDoc(doc(db, 'users', response.uid));
      user = userDoc.data();
      if (user?.organization) {
        const orgSnap = await getDoc(user.organization);
        organization = orgSnap.data();
        // For orgAdmin, auto-set their organization in localStorage
        // since they don't have the org selector dropdown
        if (claimResp?.claims?.orgAdmin && !localStorage.getItem('organization')) {
          localStorage.setItem('organization', orgSnap.id);
        }
      } else {
        organization = null;
      }
      // get organization id from localstorage if set
      // this means that user selected an organization previously
      const localOrgdata = localStorage.getItem('organization');
      // is init is to check if user slected an organization using the dropdown
      commit('organizations/SET_USER_ORGANIZATION', { organization, isInit: localOrgdata === null }, { root: true });
    }
    commit('SET_STATE', { key: 'resolved', value: true });
    commit('SET_STATE', { key: 'username', value: response?.email });
    commit('SET_STATE', { key: 'userId', value: response?.uid });
    commit('SET_STATE', { key: 'claims', value: claimResp?.claims });
    commit('SET_LOGIN_PROVIDER_INFOS', response);
    commit('SET_ROLE', claimResp?.claims);
  });
}

export function setLoginProviderInfos({ commit }, object) {
  commit('SET_LOGIN_PROVIDER_INFOS', object);
}
